import { render, staticRenderFns } from "./dao.vue?vue&type=template&id=2621aa58&scoped=true&"
import script from "./dao.vue?vue&type=script&lang=js&"
export * from "./dao.vue?vue&type=script&lang=js&"
import style0 from "./dao.vue?vue&type=style&index=0&id=2621aa58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2621aa58",
  null
  
)

export default component.exports